module.exports = __webpack_public_path__ + "img/hd1.63c90b69.jpg";